import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FiArrowLeft } from "@react-icons/all-files/fi/FiArrowLeft";
import PostShare from "./components/PostShare/PostShare";
import StoryShare from "./components/StoryShare/StoryShare";
function InstagramShare({ shareItem, onBack, type, isStory = false, }) {
    return (_jsxs("div", { className: "share-modal__instagram-view", children: [_jsxs("button", { type: "button", onClick: onBack, className: "share-modal__back", children: [_jsx(FiArrowLeft, {}), "Back"] }), isStory ? (_jsx(StoryShare, { shareItem: shareItem, type: type })) : (_jsx(PostShare, { shareItem: shareItem, type: type }))] }));
}
export default InstagramShare;
